<template>
  <a-row class="not-resize-for-mobile">
    <a-col :md="13" :sm="24">
      <a-card :bordered="false">
        <!-- 検索区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
            <a-row :gutter="24">
              <a-col :sm="24" :md="24" :lg="24" :xl="8" :xxl="8">
                <!-- 代理先 -->
                <a-form-model-item :label="$t('disp.agent')">
                  <a-input
                    :placeholder="$t('disp.ph.match', [$t('disp.agent')])"
                    v-model="queryParam.agentName"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :sm="24" :md="24" :lg="24" :xl="16" :xxl="16">
                <!-- 委譲権限 -->
                <a-form-model-item :label="$t('disp.agent.delegationPerms')">
                  <a-checkbox-group :options="delegationPermsList" @change="onPermsChange" v-model="delegationPerms" />
                </a-form-model-item>
              </a-col>
              <a-col :sm="24" :md="24" :lg="24" :xl="8" :xxl="8">
                <!-- 基準日 -->
                <a-form-model-item :label="$t('disp.agent.referenceDate')">
                  <a-date-picker
                    v-model="queryParam.referenceDate"
                    style="width: 100%"
                    :placeholder="$t('disp.ph.ymd')"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :sm="24" :md="24" :lg="24" :xl="16" :xxl="16">
                <a-form-model-item :wrapperCol="{ span: 24 }" class="width-fit-content">
                  <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                    $t('disp.btn.search')
                  }}</a-button>

                  <a-button @click="searchReset" icon="stop">
                    {{ $t('disp.btn.reset') }}
                  </a-button>

                  <a-divider type="vertical"></a-divider>

                  <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>

        <div class="ant-alert ant-alert-info div-selected-info">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>
          {{ this.$t('disp.selected') }}
          <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
          {{ this.$t('disp.item') }}
          <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
        </div>

        <div>
          <a-table
            ref="table"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
            @change="handleTableChange"
          >
            <span slot="delegationPerms" slot-scope="text, record">{{
              $getDict('delegation_perms', record.delegationPerms)
            }}</span>
            <!-- 代理期間開始日  -->
            <span slot="applyStartDate" slot-scope="text, record">{{
              record.applyStartDate | dateformat('YYYY-MM-DD')
            }}</span>
            <!-- 代理期間終了日  -->
            <span slot="applyEndDate" slot-scope="text, record">{{
              record.applyEndDate | dateformat('YYYY-MM-DD')
            }}</span>
            <!-- 操作 -->
            <span slot="action" slot-scope="text, record">
              <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDeleteDo(record)">
                <a>{{ $t('disp.btn.delete') }}</a>
              </a-popconfirm>
            </span>
          </a-table>
        </div>

        <!-- フォーム区域 -->
        <agent-modal ref="modalForm" @searchQuery="searchQuery(false, false)" @ok="modalFormOk"></agent-modal>
      </a-card>
    </a-col>
    <a-col :md="11" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="$t('disp.baseInfo')" key="1" :forceRender="true">
          <agent-info-modal ref="agentInfo" @searchQuery="searchQuery(false, false)"></agent-info-modal>
        </a-tab-pane>
      </a-tabs>
    </a-col>
  </a-row>
</template>
<script>
import { tableMixin } from '@/mixins/tableMixin'
import { deleteAction, postAction, getAction } from '@/api/manage'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import moment from 'moment'
import AgentModal from './modules/AgentModal'
import AgentInfoModal from './modules/AgentInfoModal'

export default {
  name: 'AgentManage',
  mixins: [tableMixin],
  components: {
    AgentModal,
    AgentInfoModal,
    moment,
    JDictSelectTag,
  },
  mounted() {
    this.forceClear = true
  },
  data() {
    return {
      model: {},
      // 委譲権限
      delegationPerms: [],
      // 委譲権限
      delegationPermsList: [],
      columns: [
        {
          title: this.$t('disp.agent.applyStartDate'),
          // width: 110,
          align: 'left',
          dataIndex: 'applyStartDate',
          scopedSlots: { customRender: 'applyStartDate' },
        },
        {
          title: this.$t('disp.agent.applyEndDate'),
          // width: 110,
          align: 'left',
          dataIndex: 'applyEndDate',
          scopedSlots: { customRender: 'applyEndDate' },
        },
        {
          title: this.$t('disp.agent'),
          align: 'left',
          dataIndex: 'agentName',
        },
        {
          title: this.$t('disp.agent.delegationPerms'),
          // width: 100,
          align: 'left',
          dataIndex: 'delegationPerms',
          scopedSlots: { customRender: 'delegationPerms' },
        },
        {
          title: this.$t('disp.note'),
          dataIndex: 'memo',
        },
        {
          title: this.$t('disp.operation'),
          dataIndex: 'action',
          align: 'center',
          width: 55,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/blaze-sys/k00/k0011/AgentManage/queryList',
        delete: '/blaze-sys/k00/k0011/AgentManage/delete',
      },
    }
  },
  created() {
    this.getDelegationPermsList()
    // 基準日-系统日付
    let nowDate = moment().utc().format('YYYY-MM-DD')
    this.$set(this.queryParam, 'referenceDate', nowDate)
  },
  methods: {
    /** reset */
    searchReset() {
      this.queryParam = {}
      this.delegationPerms = []

      // 基準日-系统日付
      let nowDate = moment().utc().format('YYYY-MM-DD')
      this.$set(this.queryParam, 'referenceDate', nowDate)
    },
    /** 委譲権限radio */
    getDelegationPermsList() {
      let delegationPermsList = this.$getDict('delegation_perms')
      this.delegationPermsList = []
      for (let i = 0; i < delegationPermsList.length; i++) {
        this.delegationPermsList.push({
          label: delegationPermsList[i].text,
          value: delegationPermsList[i].value,
        })
      }
    },
    /** 行選択 */
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows

      this.$refs.agentInfo.onClearSelected()
      this.$refs.agentInfo.edit(selectionRows[0])
    },
    /** 行削除 */
    handleDeleteDo: function (record) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      var that = this
      deleteAction(that.url.delete, { agentId: record.id })
        .then((res) => {
          if (res.success) {
            that.$message.success(that.$t(res.message))
            that.searchQuery(true, false)
            that.onClearSelected()
          }
        })
        .finally(() => {
          that.loading = false
        })
    },
    /** 委譲権限change */
    onPermsChange(values) {
      if (values.length > 0) {
        this.queryParam.delegationPerms = values.toString()
      } else {
        this.queryParam.delegationPerms = null
      }
    },
  },
  watch: {
    selectedRowKeys: function (e) {
      if (this.selectedRowKeys.length == 0) {
        this.$refs.agentInfo.sysAgentId = ''
      }
    },
  },
}
</script>
<style scoped></style>
